import { isDefinedString, reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import Et3Image from "../../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../../core/et3-div";

const UserImageStatus = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const pictures = reduce(
    () => getUserAdvancedStore().userData.get(userID).pictures,
    []
  );
  const userAlbumIndex = getUserAdvancedStore().userAlbumIndex.get();
  const { profilePictureStatus, selfieVerified, isPictureActive, source } =
    getUserAdvancedStore().getImageData(pictures[userAlbumIndex]);
  const imageSource = getUserAdvancedStore().getImageSource(
    isPictureActive,
    profilePictureStatus
  );

  return isDefinedString(source) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column-reverse"
      alignItems="flex-start"
      justifyContent="flex-start"
      withShadow={false}
      width={224}
      height={40}
      color={colors.all.transparent}
      style={{
        position: "absolute",
        display: "flex",
        flexWrap: "wrap",
        alignContent: "space-around"
      }}
      onClick={() => {}}
    >
      {selfieVerified === "Y" && (
        <Et3Image
          type="LOCAL"
          alt={i18n.get("USER_ALBUM_PICTURES")}
          imageName={"selfie-verified-badge"}
          size={40}
          onClick={() => {}}
          style={{ marginLeft: 0, position: "absolute" }}
        />
      )}
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER_ALBUM_PICTURES")}
        imageName={imageSource}
        size={40}
        onClick={() => {}}
        style={{}}
      />
    </ET3Div>
  ) : null;
});
export default UserImageStatus;
